module.exports = __webpack_public_path__ + "ed7885eff24143d3134d8c212545be31.pdf";